import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';

/**
 * Reenvio para aprovação após reativar papel/cadastro (homologado/aprovado ou em aprovação).
 * Em edição reativa sem esse reenvio. Usado em dashboard-approval e listagens de cadastros.
 */
@Injectable({
  providedIn: 'root',
})
export class RegistrationRequeueService {
  constructor(private api: ApiService) {}

  /**
   * POST `api/approvals/create-version/` — versão nova após mudança de ativação do cadastro/papel.
   * Usado também dentro de {@link requeueActivatedRegisterToApproval}.
   */
  async createRegistrationVersion(registerUuid: string): Promise<void> {
    const u = String(registerUuid ?? '').trim();
    if (!u) return;
    await this.api.post({
      route: 'api/approvals/create-version/',
      params: { register_uuid: u },
      body: {},
      token: true,
    });
  }

  /**
   * Snapshot do papel antes do PATCH de `active`. Reenfileira quando homologado/aprovado
   * ou em aprovação; em edição retorna false (só reativa, sem send-to-approval).
   */
  shouldRequeueAfterRegisterReactivation(paper: any): boolean {
    const status = String(paper?.status_display ?? paper?.status ?? '')
      .trim()
      .toLowerCase();

    if (/em edição|em edicao|editing|created|em_edicao/.test(status)) {
      return false;
    }

    if (/homologado|homologated|aprovado|approved/.test(status)) {
      return true;
    }

    return /em aprovação|em aprovacao|pending|in approval|em_aprovacao/.test(
      status,
    );
  }

  /**
   * POST send-to-approval → create-version → PATCH papel em "em aprovação".
   */
  async requeueActivatedRegisterToApproval(
    registerUuid: string,
    paperId: string,
  ): Promise<void> {
    await this.api.post({
      route: 'api/approvals/send-to-approval/',
      params: { register_uuid: registerUuid },
      body: {},
      token: true,
    });

    await this.createRegistrationVersion(registerUuid);

    await this.api.patch({
      route: `api/v2/registration/registration-papers/${paperId}/`,
      token: true,
      body: { status: 'em aprovação' },
    });
  }
}
